import { PropsWithChildren } from 'react'

import { AuctionDetailAuthenticatorCore } from './Core'
import { AuctionDetailAuthenticatorStoreProvider } from './Store'

export const AuctionDetailAuthenticator = ({ children }: PropsWithChildren) => {
  return (
    <AuctionDetailAuthenticatorStoreProvider>
      <AuctionDetailAuthenticatorCore />
      {children}
    </AuctionDetailAuthenticatorStoreProvider>
  )
}
